const ja_exclusive = {
  'flame'  : '【火】',
  'water'  : '【水】',
  'wind'   : '【風】',
  'light'  : '【光】',
  'shadow' : '【闇】',
  'sword'  : '【剣】',
  'blade'  : '【刀】',
  'dagger' : '【短剣】',
  'axe'    : '【斧】',
  'lance'  : '【槍】',
  'bow'    : '【弓】',
  'wand'   : '【ロッド】',
  'staff'  : '【杖】',
}

export default ja_exclusive